var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5499 7.94707C10.5499 7.09083 11.2624 6.75958 12.4136 6.75958C14.319 6.80075 16.1886 7.28453 17.8748 8.17269V3.00401C16.1361 2.32071 14.2817 1.98009 12.4136 2.0009C7.97621 2.0009 5 4.32524 5 8.20644C5 14.2789 13.3386 13.2926 13.3386 15.9101C13.3386 16.9338 12.4636 17.2513 11.2324 17.2513C9.41681 17.2513 7.07185 16.5001 5.2325 15.5001V20.7363C7.12623 21.5602 9.16784 21.9902 11.233 22C15.7936 22 18.9373 19.7469 18.9373 15.7982C18.9373 9.24455 10.5499 10.4152 10.5499 7.94832V7.94707Z",
    fill: "#6772E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogoDark);
export default __webpack_public_path__ + "static/media/stripe-logo-dark.a7350f36b3dc9ba333b3c600eccd39c9.svg";
export { ForwardRef as ReactComponent };